import { Component, OnInit, Signal, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-menu-page-item',
    templateUrl: './menu-page-item.component.html',
    styleUrls: ['./menu-page-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, NgClass]
})
export class MenuPageItemComponent implements OnInit {

  id = input.required<number>();
  link = input.required<string>();
  isFavorite = input<boolean>(false);
  onFavoriteChanged = output<any>();
  isFavoriteListItem = input<boolean>(false);

  showFavoriteIcon: Signal<boolean>;

  constructor() { }

  ngOnInit(): void {
     this.showFavoriteIcon = computed(() => this.isFavorite() || this.isFavoriteListItem());
  }

  favoriteChange(values:any):void {
    var changeEvent = {id: this.id(), value: values.currentTarget.checked}
    this.onFavoriteChanged.emit(changeEvent);
  }

}
